module.exports = __webpack_public_path__ + "static/media/info-blue.4f447e00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/info-blue.svg
// module id = 217
// module chunks = 2